/* tslint:disable */
/* eslint-disable */
/**
 * ald-routing-api
 * Node.js OpenAPI implemented by TSOA
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TollByRouteIdsRequestBody
 */
export interface TollByRouteIdsRequestBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof TollByRouteIdsRequestBody
     */
    routeIds: Array<string>;
}

export function TollByRouteIdsRequestBodyFromJSON(json: any): TollByRouteIdsRequestBody {
    return TollByRouteIdsRequestBodyFromJSONTyped(json, false);
}

export function TollByRouteIdsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TollByRouteIdsRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'routeIds': json['routeIds'],
    };
}

export function TollByRouteIdsRequestBodyToJSON(value?: TollByRouteIdsRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'routeIds': value.routeIds,
    };
}


